(function ($, root, undefined) {

	$(function () {
		'use strict';

    // Scroll to top
    var btn = $('#button');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    // Scroll to anchor
    var $root = $('html, body');
    $('a[href^="#"]').click(function() {
      if($(this).hasClass('.anchor-link')) {
        var href = $.attr(this, 'href');
        $root.animate({scrollTop: $(href).offset().top}, 500, function() {
          window.location.hash = href;
        });
        return false;
      }
    });

    // Fonction fixe navigation
    fixeNav();

    function fixeNav() {
      var lastScrollTop = 0;
      var threshold = 200;

      $(window).scroll(function(event){
        var currentScrollTop = $(this).scrollTop();

        if (lastScrollTop < threshold){
          $('.bkgHeader').removeClass("stickcolored");
        } else {
          $('.bkgHeader').addClass("stickcolored");
        }

        if (currentScrollTop > lastScrollTop && lastScrollTop > threshold){
          $('.header').addClass("stickhidden");
        } else {
          $('.header').removeClass("stickhidden");
        }

        lastScrollTop = currentScrollTop;
      });
    }

    initSite();

    function initSite() {
      // Toogle Navigation Mobile
      $('.menu-item-has-children').click(function(){
        //Expand or collapse this panel
        $(".menu-item-has-children").not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });

      // Classe sur body quand le menu mobile s'ouvre / se ferme (breakpoint = 1040px)
      var $mobileMenuCheckbox = $('#checkbox');
      var mobileMenuBreakpoint = 1040;

      if ($mobileMenuCheckbox.length) {
        function syncMobileMenuClass() {
          $('body').toggleClass('is-mobile-menu-open', $mobileMenuCheckbox.prop('checked'));
        }
        function closeMobileMenuIfDesktop() {
          if (window.innerWidth > mobileMenuBreakpoint && $mobileMenuCheckbox.prop('checked')) {
            $mobileMenuCheckbox.prop('checked', false).trigger('change');
          }
        }
        $mobileMenuCheckbox.on('change', syncMobileMenuClass);
        syncMobileMenuClass();
        $(window).on('resize', closeMobileMenuIfDesktop);
      }

      // Fermer le menu mobile au scroll
      $(window).on('scroll', function() {
        if ($mobileMenuCheckbox.length && $mobileMenuCheckbox.prop('checked')) {
          $mobileMenuCheckbox.prop('checked', false).trigger('change');
        }
      });
    }

    // Initialisation des Swipers pour le block texte-image
    initTexteImageSwipers();
    initTemoignagesSwipers();
    initMosaiqueSwipers();
    initPortraitSwipers();
    initSelecteurFormationsSwipers();

    function initTemoignagesSwipers() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      // Trouver tous les swipers dans les blocks témoignages
      var swiperElements = document.querySelectorAll('.block-temoignages__swiper');
      
      swiperElements.forEach(function(swiperElement) {
        // Vérifier si ce swiper n'a pas déjà été initialisé
        if (swiperElement.swiper) {
          return;
        }

        // Trouver les boutons de navigation
        var section = swiperElement.closest('.block-temoignages');
        var prevButton = section ? section.querySelector('.block-temoignages__nav-button--prev') : null;
        var nextButton = section ? section.querySelector('.block-temoignages__nav-button--next') : null;

        // Configuration Swiper en mode autowidth
        var swiperConfig = {
          slidesPerView: 'auto',
          spaceBetween: 80,
          grabCursor: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            320: {
              spaceBetween: 30,
            },
            768: {
              spaceBetween: 60,
            },
          },
        };

        new Swiper(swiperElement, swiperConfig);
      });
    }

    function initTexteImageSwipers() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      // Trouver tous les swipers dans les blocks texte-image
      var swiperElements = document.querySelectorAll('.block-texte-image__swiper');
      
      swiperElements.forEach(function(swiperElement) {
        // Vérifier si ce swiper n'a pas déjà été initialisé
        if (swiperElement.swiper) {
          return;
        }

        // Trouver le parent section pour détecter la position de l'image
        var section = swiperElement.closest('.block-texte-image');
        var isImageLeft = section && section.classList.contains('block-texte-image--image-left');

        var nextButton = swiperElement.querySelector('.swiper-button-next');
        var prevButton = swiperElement.querySelector('.swiper-button-prev');

        // Configuration Swiper
        var swiperConfig = {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
            rotate: 0,
            stretch: 220,
            depth: 300,
            modifier: 1,
            slideShadows: false,
          },
        };

        // Activer RTL si l'image est à gauche
        if (isImageLeft) {
          swiperConfig.rtl = true;
          // En RTL, Swiper inverse les boutons, donc on inverse les sélecteurs
          // pour que le bouton de gauche soit "next" et celui de droite "prev"
          swiperConfig.navigation = {
            nextEl: prevButton,  // Le bouton de gauche devient "next" en RTL
            prevEl: nextButton,  // Le bouton de droite devient "prev" en RTL
          };
        } else {
          swiperConfig.navigation = {
            nextEl: nextButton,
            prevEl: prevButton,
          };
        }

        new Swiper(swiperElement, swiperConfig);
      });
    }

    // Réinitialiser les swipers si du contenu est chargé dynamiquement
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        var shouldReinit = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1 && node.querySelector && (
                node.querySelector('.block-texte-image__swiper') ||
                node.querySelector('.block-temoignages__swiper') ||
                node.querySelector('.block-mosaique') ||
                node.querySelector('.block-portrait__formateurs')
              )) {
                shouldReinit = true;
              }
            });
          }
        });
        if (shouldReinit) {
          setTimeout(function() {
            initTexteImageSwipers();
            initTemoignagesSwipers();
            initMosaiqueSwipers();
            initPortraitSwipers();
            initSelecteurFormationsSwipers();
          }, 100);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Initialisation des sliders mosaique
    function initMosaiqueSwipers() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      // Trouver tous les blocs mosaique
      var mosaiqueBlocks = document.querySelectorAll('.block-mosaique');
      
      mosaiqueBlocks.forEach(function(block) {
        // Vérifier si ce bloc a déjà été initialisé
        if (block.hasAttribute('data-initialized')) {
          return;
        }
        block.setAttribute('data-initialized', 'true');

        // Trouver tous les sliders dans ce bloc
        var swipers = block.querySelectorAll('.block-mosaique__swiper');
        var prevButton = block.querySelector('.block-mosaique__nav-button--prev');
        var nextButton = block.querySelector('.block-mosaique__nav-button--next');
        
        if (swipers.length === 0) {
          return;
        }

        var swiperInstances = [];
        
        // Initialiser chaque slider indépendamment
        swipers.forEach(function(swiperElement) {
          if (swiperElement.swiper) {
            return;
          }

          var swiperConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: false,
            allowTouchMove: true,
          };

          var swiperInstance = new Swiper(swiperElement, swiperConfig);
          swiperInstances.push(swiperInstance);
        });

        // Gérer la navigation unique mais non synchronisée avec délais aléatoires
        if (prevButton && nextButton && swiperInstances.length > 0) {
          prevButton.addEventListener('click', function() {
            // Chaque slider avance indépendamment avec un délai aléatoire faible
            swiperInstances.forEach(function(swiper, index) {
              // Délai aléatoire entre 0 et 500ms pour chaque slider
              var randomDelay = Math.random() * 500;
              setTimeout(function() {
                swiper.slidePrev();
              }, randomDelay);
            });
          });

          nextButton.addEventListener('click', function() {
            // Chaque slider avance indépendamment avec un délai aléatoire faible
            swiperInstances.forEach(function(swiper, index) {
              // Délai aléatoire entre 0 et 500ms pour chaque slider
              var randomDelay = Math.random() * 500;
              setTimeout(function() {
                swiper.slideNext();
              }, randomDelay);
            });
          });
        }
      });
    }

    // Initialisation des swipers portrait (images + contenu synchronisés)
    function initPortraitSwipers() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      // Trouver tous les blocs portrait
      var portraitBlocks = document.querySelectorAll('.block-portrait__formateurs');
      
      portraitBlocks.forEach(function(block) {
        // Vérifier si ce bloc a déjà été initialisé
        if (block.hasAttribute('data-initialized')) {
          return;
        }
        block.setAttribute('data-initialized', 'true');

        var swiperImages = block.querySelector('.block-portrait__swiper-images');
        var swiperContent = block.querySelector('.block-portrait__swiper-content');
        var prevButton = block.querySelector('.block-portrait__nav-button--prev');
        var nextButton = block.querySelector('.block-portrait__nav-button--next');

        if (!swiperImages || !swiperContent) {
          return;
        }

        // Configuration pour le swiper des images
        var swiperImagesConfig = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          allowTouchMove: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        };

        // Configuration pour le swiper du contenu
        var swiperContentConfig = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          allowTouchMove: true,
        };

        // Initialiser les swipers
        var swiperImagesInstance = new Swiper(swiperImages, swiperImagesConfig);
        var swiperContentInstance = new Swiper(swiperContent, swiperContentConfig);

        // Synchroniser les swipers
        swiperImagesInstance.controller.control = swiperContentInstance;
        swiperContentInstance.controller.control = swiperImagesInstance;
      });
    }

    // Initialisation des accordéons pour le bloc onglets
    initOngletsAccordions();

    function initOngletsAccordions() {
      var accordions = document.querySelectorAll('.block-onglets__tabs[data-accordion]');
      
      accordions.forEach(function(accordion) {
        // Vérifier si cet accordéon a déjà été initialisé
        if (accordion.hasAttribute('data-initialized')) {
          return;
        }
        accordion.setAttribute('data-initialized', 'true');
        
        var buttons = accordion.querySelectorAll('[data-tab-button]');
        var contents = accordion.querySelectorAll('[data-tab-content]');
        
        // Initialiser le premier onglet s'il est marqué comme ouvert
        buttons.forEach(function(button, index) {
          var content = contents[index];
          var isExpanded = button.getAttribute('aria-expanded') === 'true';
          
          if (isExpanded && content) {
            // Ouvrir le premier onglet
            content.style.maxHeight = 'none';
            var height = content.scrollHeight;
            content.style.maxHeight = height + 'px';
            content.style.paddingTop = '';
            content.style.paddingBottom = '';
          }
        });
        
        buttons.forEach(function(button, index) {
          // Vérifier si le bouton a déjà un listener
          if (button.hasAttribute('data-listener-attached')) {
            return;
          }
          button.setAttribute('data-listener-attached', 'true');
          
          button.addEventListener('click', function() {
            var content = contents[index];
            var isExpanded = button.getAttribute('aria-expanded') === 'true';
            
            // Compter combien d'onglets sont ouverts
            var openCount = 0;
            buttons.forEach(function(btn) {
              if (btn.getAttribute('aria-expanded') === 'true') {
                openCount++;
              }
            });
            
            // Si on essaie de fermer le dernier onglet ouvert, ne rien faire
            if (isExpanded && openCount === 1) {
              return;
            }
            
            // Fermer tous les autres onglets dans cet accordéon
            buttons.forEach(function(otherButton, otherIndex) {
              if (otherIndex !== index) {
                var otherContent = contents[otherIndex];
                otherButton.setAttribute('aria-expanded', 'false');
                otherContent.setAttribute('aria-hidden', 'true');
                otherContent.style.maxHeight = '0';
                otherContent.style.paddingTop = '0';
                otherContent.style.paddingBottom = '0';
              }
            });
            
            // Toggle l'onglet actuel
            if (isExpanded) {
              // Fermer
              button.setAttribute('aria-expanded', 'false');
              content.setAttribute('aria-hidden', 'true');
              // Utiliser la hauteur actuelle pour une transition fluide
              var currentHeight = content.scrollHeight;
              content.style.maxHeight = currentHeight + 'px';
              // Forcer le reflow
              content.offsetHeight;
              // Puis réduire à 0
              content.style.maxHeight = '0';
              content.style.paddingTop = '0';
              content.style.paddingBottom = '0';
            } else {
              // Ouvrir
              button.setAttribute('aria-expanded', 'true');
              content.setAttribute('aria-hidden', 'false');
              // Réinitialiser le max-height pour calculer la hauteur réelle
              content.style.maxHeight = 'none';
              var height = content.scrollHeight;
              // Réinitialiser puis animer
              content.style.maxHeight = '0';
              // Forcer le reflow
              content.offsetHeight;
              // Animer vers la hauteur réelle
              content.style.maxHeight = height + 'px';
              content.style.paddingTop = '';
              content.style.paddingBottom = '';
            }
          });
        });
      });
    }

    // Réinitialiser les accordéons si du contenu est chargé dynamiquement
    if (typeof MutationObserver !== 'undefined') {
      var accordionObserver = new MutationObserver(function(mutations) {
        var shouldReinit = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1 && node.querySelector && node.querySelector('.block-onglets__tabs[data-accordion]')) {
                shouldReinit = true;
              }
            });
          }
        });
        if (shouldReinit) {
          setTimeout(initOngletsAccordions, 100);
        }
      });

      accordionObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Initialisation des swipers pour le block selecteur-formations
    function initSelecteurFormationsSwipers() {
      const swiperSliderDoublePicto = new Swiper(".block-selecteur-formations__swiper-selector", {
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerGroup: 1, // Navigation 1 par 1
        allowTouchMove: true,
        noSwiping: true,
  
        observer: true,
        observeParents: true,
        parallax:true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 25,
          }
        }
      });
  
      const swiperSliderDoubleImage = new Swiper(".block-selecteur-formations__swiper-main", {
        slidesPerView: 1,
        allowTouchMove: false,
        thumbs: {
          swiper: swiperSliderDoublePicto
        },
        navigation: {
          nextEl: ".block-selecteur-formations__nav-button--next",
          prevEl: ".block-selecteur-formations__nav-button--prev",
        },
      });
  
      const swiperSliderDoubleStep = new Swiper(".block-selecteur-formations__swiper-content", {
        slidesPerView: 1,
        spaceBetween: 25,
        allowTouchMove: false,
      });
  
      swiperSliderDoubleImage.controller.control = swiperSliderDoubleStep;
    }

    /**********************************************/
    /************* FILTRES ARTICLES ***************/
    /**********************************************/

    // Gestion des filtres dynamiques en AJAX
    var $filtersForm = $('#ressources-filters-form');
    if ($filtersForm.length) {
      var baseUrl = $filtersForm.attr('action') || window.location.pathname;
      var isLoading = false;
      
      // Définir l'état initial pour l'historique du navigateur
      if (window.history.state === null) {
        var urlParams = new URLSearchParams(window.location.search);
        var initialCategoryFilters = urlParams.getAll('category_filter');
        var initialUniversFilters = urlParams.getAll('univers_filter');
        var initialPage = parseInt(urlParams.get('paged')) || 1;
        
        window.history.replaceState({
          categoryFilters: initialCategoryFilters,
          universFilters: initialUniversFilters,
          page: initialPage
        }, '', window.location.href);
      }
      
      // Fonction pour charger les posts via AJAX
      function loadPosts(page) {
        if (isLoading) return;
        
        isLoading = true;
        
        // Récupérer les filtres actifs
        var categoryFilters = [];
        $('input[name="category_filter[]"]:checked').each(function() {
          categoryFilters.push($(this).val());
        });
        
        var universFilters = [];
        $('input[name="univers_filter[]"]:checked').each(function() {
          universFilters.push($(this).val());
        });
        
        // Afficher un loader
        var $postsContainer = $('.block-blog__posts');
        $postsContainer.css('opacity', '0.5');
        
        // Requête AJAX
        var ajaxData = {
          action: 'filter_posts',
          nonce: postsAjax.nonce,
          category_filter: categoryFilters,
          univers_filter: universFilters,
          paged: page || 1
        };
        
        // Ajouter la langue courante si Polylang est actif
        if (postsAjax.current_lang) {
          ajaxData.lang = postsAjax.current_lang;
        }
        
        $.ajax({
          url: postsAjax.ajax_url,
          type: 'POST',
          data: ajaxData,
          success: function(response) {
            if (response.success) {
              var $actuLoop = $('.actus-loop');
              
              // 1. Mettre à jour les posts
              $postsContainer.html(response.data.posts_html);
              $postsContainer.css('opacity', '1');
              
              // 2. Gérer le message "no results" (toujours supprimer l'ancien d'abord)
              $actuLoop.find('.container.center').remove();
              if (!response.data.has_posts && response.data.no_results_html) {
                $postsContainer.after(response.data.no_results_html);
              }
              
              // 3. Mettre à jour la pagination
              var $paginationContainer = $('.actus-pagination');
              $paginationContainer.remove(); // Toujours supprimer l'ancienne
              if (response.data.pagination_html) {
                $actuLoop.append(response.data.pagination_html);
              }
              
              // 4. Mettre à jour les filtres actifs
              if (response.data.active_filters_html) {
                $('#active-filters-container').html(response.data.active_filters_html);
              }
              
              // 5. Afficher/cacher le bouton de réinitialisation
              if (response.data.has_filters) {
                $('.ressources-filters__actions').show();
              } else {
                $('.ressources-filters__actions').hide();
              }
              
              // 6. Réattacher les événements de pagination
              attachPaginationEvents();
              
              // 7. Mettre à jour l'URL
              updateURL(categoryFilters, universFilters, page || 1);
              
              // 8. Scroll fluide vers le formulaire de filtres
              var $filtersForm = $('#ressources-filters-form');
              if ($filtersForm.length) {
                $('html, body').animate({
                  scrollTop: $filtersForm.offset().top - 200
                }, 400);
              }
            } else {
              $postsContainer.html('');
              $postsContainer.css('opacity', '1');
              $('.actus-loop').find('.container.center').remove();
              $postsContainer.after('<div class="container center"><p>Une erreur est survenue.</p></div>');
            }
            isLoading = false;
          },
          error: function() {
            $postsContainer.html('');
            $postsContainer.css('opacity', '1');
            $('.actus-loop').find('.container.center').remove();
            $postsContainer.after('<div class="container center"><p>Une erreur est survenue.</p></div>');
            isLoading = false;
          }
        });
      }
      
      // Fonction pour mettre à jour l'URL
      function updateURL(categoryFilters, universFilters, page) {
        var queryParts = [];
        
        // Ajouter les catégories
        categoryFilters.forEach(function(category) {
          queryParts.push('category_filter=' + encodeURIComponent(category));
        });
        
        // Ajouter les univers métiers
        universFilters.forEach(function(univers) {
          queryParts.push('univers_filter=' + encodeURIComponent(univers));
        });
        
        // Ajouter la page si différente de 1
        if (page && page > 1) {
          queryParts.push('paged=' + page);
        }
        
        var newUrl = baseUrl;
        if (queryParts.length > 0) {
          newUrl += '?' + queryParts.join('&');
        }
        
        // Mettre à jour l'URL sans recharger la page
        window.history.pushState({
          categoryFilters: categoryFilters,
          universFilters: universFilters,
          page: page
        }, '', newUrl);
      }
      
      // Gérer le bouton retour du navigateur
      window.addEventListener('popstate', function(e) {
        if (e.state) {
          // Mettre à jour les checkboxes selon l'état
          $('input[name="category_filter[]"]').prop('checked', false);
          $('input[name="univers_filter[]"]').prop('checked', false);
          
          if (e.state.categoryFilters) {
            e.state.categoryFilters.forEach(function(slug) {
              $('input[name="category_filter[]"][value="' + slug + '"]').prop('checked', true);
            });
          }
          
          if (e.state.universFilters) {
            e.state.universFilters.forEach(function(slug) {
              $('input[name="univers_filter[]"][value="' + slug + '"]').prop('checked', true);
            });
          }
          
          // Recharger les posts
          loadPosts(e.state.page || 1);
        } else {
          // Recharger la page si pas d'état
          window.location.reload();
        }
      });
      
      // Fonction pour attacher les événements de pagination
      function attachPaginationEvents() {
        // Utiliser la délégation d'événements sur le document
        // Écouter à la fois .ajax-pagination-link et .page-numbers a
        $(document).off('click', '.ajax-pagination-link, .pagination a.page-numbers');
        $(document).on('click', '.ajax-pagination-link, .pagination a.page-numbers', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var page = $(this).data('page');
          if (page) {
            loadPosts(page);
          }
          return false;
        });
      }
      
      // Attacher les événements de pagination au chargement
      attachPaginationEvents();
      
      // Gérer l'ouverture/fermeture des panneaux
      $('.ressources-filters__select-trigger').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $trigger = $(this);
        var $wrapper = $trigger.closest('.ressources-filters__select-wrapper');
        var $panel = $wrapper.find('.ressources-filters__select-panel');
        var isExpanded = $trigger.attr('aria-expanded') === 'true';
        
        // Fermer tous les autres panneaux
        $('.ressources-filters__select-panel').removeClass('is-open');
        $('.ressources-filters__select-trigger').attr('aria-expanded', 'false');
        
        // Ouvrir/fermer le panneau actuel
        if (!isExpanded) {
          $panel.addClass('is-open');
          $trigger.attr('aria-expanded', 'true');
        }
      });
      
      // Fermer les panneaux quand on clique ailleurs
      $(document).on('click', function(e) {
        if (!$(e.target).closest('.ressources-filters__select-wrapper').length) {
          $('.ressources-filters__select-panel').removeClass('is-open');
          $('.ressources-filters__select-trigger').attr('aria-expanded', 'false');
        }
      });
      
      // Empêcher la fermeture quand on clique dans le panneau
      $('.ressources-filters__select-panel').on('click', function(e) {
        e.stopPropagation();
      });
      
      // Écouter les changements sur les checkboxes
      $('input[name="category_filter[]"], input[name="univers_filter[]"]').on('change', function() {
        loadPosts(1); // Toujours retourner à la page 1 quand on change les filtres
      });
      
      // Gérer le clic sur "Réinitialiser les filtres"
      $('.ressources-filters__reset').on('click', function(e) {
        e.preventDefault();
        // Décocher toutes les checkboxes
        $('input[name="category_filter[]"], input[name="univers_filter[]"]').prop('checked', false);
        // Recharger les posts
        loadPosts(1);
      });
      
      // Gérer le clic sur les tags de filtres actifs
      $(document).on('click', '.ressources-filters__active-tag-remove', function(e) {
        e.preventDefault();
        var $tag = $(this).closest('.ressources-filters__active-tag');
        var filterType = $tag.data('filter-type');
        var filterSlug = $tag.data('filter-slug');
        
        // Décocher la checkbox correspondante
        if (filterType === 'category') {
          $('input[name="category_filter[]"][value="' + filterSlug + '"]').prop('checked', false);
        } else if (filterType === 'univers') {
          $('input[name="univers_filter[]"][value="' + filterSlug + '"]').prop('checked', false);
        }
        
        // Recharger les posts
        loadPosts(1);
      });
    }

    /**************************************************/
    /************* FIN FILTRES ARTICLES ***************/
    /**************************************************/

    /**************************************************/
    /********** MASONRY LISTING FORMATIONS ***********/
    /**************************************************/
    var $grid = $('.block-listing-formations__list');
    
    if ($grid.length > 0 && typeof imagesLoaded !== 'undefined' && typeof Masonry !== 'undefined') {
      // Breakpoints (correspondent aux breakpoints SCSS)
      var breakpoints = {
        mobile: 0,
        mobileMin: 400,
        tablet: 768,
        desktop: 960
      };

      // Fonction pour obtenir le nombre de colonnes selon la largeur
      // Seuils : > 800px = 2 colonnes, > 1200px = 3 colonnes
      function getColumnCount(containerWidth) {
        if (containerWidth > 1200) {
          return 3;
        } else if (containerWidth > 800) {
          return 2;
        } else {
          return 1;
        }
      }

      // Fonction pour initialiser ou mettre à jour Masonry
      function initOrUpdateMasonry() {
        var windowWidth = $(window).width();
        var gutter = 40;
        var hasMasonry = $grid.data('masonry') !== undefined;
        var needsMasonry = windowWidth >= breakpoints.tablet;

        // Si on n'a pas besoin de Masonry (mobile)
        if (!needsMasonry) {
          // Détruire seulement si Masonry existe (évite les destructions inutiles)
          if (hasMasonry) {
            $grid.masonry('destroy');
          }
          // Remettre les items à 100% de largeur sur mobile
          $grid.find('.block-listing-formations__item').css('width', '100%');
          return;
        }

        // Calculer la largeur des colonnes
        // Utiliser la largeur de la fenêtre pour déterminer le nombre de colonnes
        var containerWidth = $grid.width();
        var columnCount = getColumnCount(windowWidth);
        var columnWidth = (containerWidth - (gutter * (columnCount - 1))) / columnCount;
        
        // Vérifier que chaque item fait au moins 400px, sinon réduire le nombre de colonnes
        while (columnWidth < 400 && columnCount > 1) {
          columnCount--;
          columnWidth = (containerWidth - (gutter * (columnCount - 1))) / columnCount;
        }

        // Si après calcul on n'a qu'une seule colonne, pas besoin de Masonry
        if (columnCount === 1) {
          if (hasMasonry) {
            $grid.masonry('destroy');
          }
          $grid.find('.block-listing-formations__item').css('width', '100%');
          return;
        }

        // Si Masonry est déjà initialisé, mettre à jour
        if (hasMasonry) {
          var masonryInstance = $grid.data('masonry');
          // Mettre à jour les options seulement si elles ont changé
          if (masonryInstance.columnWidth !== columnWidth || masonryInstance.gutter !== gutter) {
            masonryInstance.options.columnWidth = columnWidth;
            masonryInstance.options.gutter = gutter;
            masonryInstance.columnWidth = columnWidth;
            masonryInstance.gutter = gutter;
            
            // Mettre à jour la largeur des items
            $grid.find('.block-listing-formations__item').css('width', columnWidth + 'px');
            
            $grid.masonry('reloadItems');
            $grid.masonry('layout');
          }
        } else {
          // Initialiser Masonry après le chargement des images
          $grid.imagesLoaded(function() {
            // Définir la largeur des items avant l'initialisation
            $grid.find('.block-listing-formations__item').css('width', columnWidth + 'px');
            
            $grid.masonry({
              itemSelector: '.block-listing-formations__item',
              columnWidth: columnWidth,
              percentPosition: false,
              gutter: gutter,
              horizontalOrder: true,
              isOriginLeft: true
            });
          });
        }
      }

      // Initialiser au chargement
      var initialWidth = $(window).width();
      if (initialWidth >= breakpoints.tablet) {
        initOrUpdateMasonry();
      }

      // Réappliquer lors du redimensionnement (avec debounce)
      var resizeTimer;
      $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          initOrUpdateMasonry();
        }, 250);
      });
    }
    /**************************************************/
    /******** FIN MASONRY LISTING FORMATIONS **********/
    /**************************************************/
	});

})(jQuery, this);


